import { useState } from 'react';
import { Link } from 'react-router-dom';
import Hero from './components/Hero';
import ServicesOverview from './components/ServicesOverview';
import ProcessTimeline from './components/ProcessTimeline';
import PropertyManagement from './components/PropertyManagement';
import TrainingModule from './components/TrainingModule';
import VendorPartnership from './components/VendorPartnership';
import ProductMarketplace from './components/ProductMarketplace';
import GalleryPreview from './components/GalleryPreview';
import Testimonials from './components/Testimonials';
import AboutSnapshot from './components/AboutSnapshot';
import Newsletter from './components/Newsletter';
import SEOHead from '../../components/SEOHead';

export default function HomePage() {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';
  
  const schema = {
    "@context": "https://schema.org",
    "@type": "ProfessionalService",
    "name": "Aire University",
    "description": "Expert Airbnb property setup and management services in Newark, Delaware. Transform your property into a profitable short-term rental with our comprehensive training and support.",
    "url": siteUrl,
    "telephone": "+1-302-500-3373",
    "email": "Aireuniversity@gmail.com",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "2043 Pulaski Hwy",
      "addressLocality": "Newark",
      "addressRegion": "DE",
      "postalCode": "19702",
      "addressCountry": "US"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": "39.6789012",
      "longitude": "-75.7234567"
    },
    "areaServed": {
      "@type": "State",
      "name": "Delaware"
    },
    "priceRange": "$299-$2999",
    "openingHoursSpecification": [
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
        "opens": "09:00",
        "closes": "18:00"
      },
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": "Saturday",
        "opens": "10:00",
        "closes": "16:00"
      }
    ],
    "sameAs": []
  };

  return (
    <>
      <SEOHead
        title="Newark Delaware Airbnb Setup Services | Aire University Property Management"
        description="Expert Airbnb property setup and management services in Newark, Delaware. Transform your property into a profitable short-term rental with our comprehensive training, design, and optimization services. Call 302-500-3373 for a free consultation."
        keywords="Airbnb setup Newark Delaware, property management Delaware, short-term rental setup, Airbnb training, vacation rental management, Airbnb optimization, Newark DE property services"
        schema={schema}
      />
      <div className="min-h-screen bg-white">
        <Hero />
        <ServicesOverview />
        <ProcessTimeline />
        <PropertyManagement />
        <TrainingModule />
        <VendorPartnership />
        <ProductMarketplace />
        <GalleryPreview />
        <Testimonials />
        <AboutSnapshot />
        <Newsletter />
      </div>
    </>
  );
}
